import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
Vue.use(Router);
const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [{
        path: "",
        component: () =>
            import ("./layouts/Main.vue"),
        children: [{
            path: "/",
            component: () =>
                import ("./views/List.vue")
        }, {
            path: "/login/",
            component: () =>
                import ("./views/Login.vue")
        }, {
            path: "*",
            redirect: "/login/"
        }]
    }]
});
router.beforeEach((to, from, next) => {
    axios.get("/api/auth/").then(() => {
        next();
    }).catch(() => {
        if (to.path != "/login/") {
            router.push("/login/");
        }
        next();
    });
});
export default router;